import { atom, getDefaultStore } from 'jotai';

import { DEFAULT_ALARM_SOUND_SETTINGS, type AlarmSoundSettings } from '@/shared/api/alarm-sound-settings-client';

/**
 * 공용보드 로컬 Jotai Provider 안에서도 전역 알림 레이어와 같은 설정을 공유합니다.
 */
export const alarmSoundSettingsStore = getDefaultStore();

/** 알림음 설정 atom이 항상 전역 store를 사용하도록 고정합니다. */
export const alarmSoundSettingsStoreOptions = { store: alarmSoundSettingsStore } as const;

/** 브라우저 알림음 설정을 전역으로 공유합니다. */
export const alarmSoundSettingsAtom = atom<AlarmSoundSettings>(DEFAULT_ALARM_SOUND_SETTINGS);

/** 알림음 설정의 최초 조회 완료 여부입니다. */
export const alarmSoundSettingsLoadedAtom = atom(false);

/** 알림음 설정 조회 또는 저장 진행 상태입니다. */
export const alarmSoundSettingsPendingAtom = atom(false);
